export { TeacherHeaderDetailsModule } from './teacher-header-details.component';
